<template>
    <div class="support help-articles-search">
        <!-- Search field -->
        <div class="form-group">
            <i class="wa-icon-search" v-if="!isLoading"></i>
            <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
            <input type="text" v-model="query" class="form-control form-control-lg" :placeholder="'support.search.placeholder' | trans" />
        </div>

        <!-- Results -->
        <div class="results">
            <a :href="$window.route('frontend.support.helpArticles.show', { helpArticle: helpArticle.permalink })" class="help-article-link" target="_blank" v-for="helpArticle in results">
                <i class="fas fa-book-open align-self-center mr-3"></i>
                {{ helpArticle.title }}
                <i class="fa fa-external-link"></i>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data() {
            return {
                query: '',
                results: [],
                isLoading: false,
            }
        },
        mounted() {},
        computed: {},
        methods: {
            search() {
                var self = this;
                this.isLoading = true

                axios.get(route('api.frontend.support.helpArticles.search'), {
                    params: {
                        query: this.query
                    }
                }).then(function (response) {
                    self.results = response.data.data
                    self.isLoading = false

                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('Leider ist bei der Suche ein Fehler aufgetreten.');
                });
            }
        },
        watch: {
            query() {
                this.search()
            }
        }
    }
</script>
